import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-compensatory-off-policy',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './compensatory-off-policy.component.html',
  styleUrl: './compensatory-off-policy.component.scss'
})
export class CompensatoryOffPolicyComponent {
  isDisabled: boolean = false;
  AttendenceData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private compensatoryOff: CompensatoryOffService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_CompOffRuleLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_CompOffRuleLoad() {
    this.isDisabled = true;
    this.compensatoryOff.ESS_CompOffRuleLoad({ SelectType: 1, ESS_AttendanceRuleID: 0 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
          this.TableDatas.forEach((element: any) => {
            element.WebESSApplicability = response.Table1.filter((e: any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
          });
        }else{
          this.TableDatas = [];
        }

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    // const data = {
    //   SelectType: 'AttendanceRuleBulkUpload',
    //   Year: ''
    // }
    // this.download.ESS_ExcelDump(data).subscribe(
    //   data => {
    //     this.AttendenceData = data;
    //     this.download.exportToExcel(this.AttendenceData, "AttendencePolicies_data");
    //   });
  }
}
